import { render, staticRenderFns } from "./ComparePanel.vue?vue&type=template&id=7398de62&scoped=true"
import script from "./ComparePanel.vue?vue&type=script&lang=ts"
export * from "./ComparePanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7398de62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7398de62')) {
      api.createRecord('7398de62', component.options)
    } else {
      api.reload('7398de62', component.options)
    }
    module.hot.accept("./ComparePanel.vue?vue&type=template&id=7398de62&scoped=true", function () {
      api.rerender('7398de62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ComparePanel.vue"
export default component.exports